import { render, staticRenderFns } from "./salaryProcessSet.vue?vue&type=template&id=9c74f38e&scoped=true&"
import script from "./salaryProcessSet.vue?vue&type=script&lang=js&"
export * from "./salaryProcessSet.vue?vue&type=script&lang=js&"
import style0 from "./salaryProcessSet.vue?vue&type=style&index=0&id=9c74f38e&prod&lang=scss&scoped=true&"
import style1 from "./salaryProcessSet.vue?vue&type=style&index=1&id=9c74f38e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c74f38e",
  null
  
)

export default component.exports